import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
class Log extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  render() {
    if (isLoaded(this.props.resource)) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /> <h1>{this.props.resource.title}</h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">

                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.props.resource.content
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    if (auth)
      return {
        resource: dataToJS(firebase, `/resources/${match.params.resourceId}`)
      };
    return null;
  })(
    firebaseConnect(({ match, auth }) => {
      return [`/resources`];
    })(Log)
  )
);



// WEBPACK FOOTER //
// ./src/routes/resource/index.js